import { useEffect, useState } from 'preact/hooks';
import { detectOS, getAdminStoreUrl, ADMIN_APP_STORE_URL, ADMIN_PLAY_STORE_URL } from '../utils/appStore';
import styles from '../styles/AppRedirect.module.css';
import logoImage from '../assets/images/logo.png';
import textLogoImage from '../assets/images/olym_text_logo.png';

export default function AdminAppDownloadRedirect() {
  const [status, setStatus] = useState('loading');
  const os = detectOS();

  useEffect(() => {
    const timer = setTimeout(() => {
      const storeUrl = getAdminStoreUrl(os);
      if (storeUrl) {
        window.location.href = storeUrl;
        setStatus('redirecting');
      } else {
        setStatus('desktop');
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [os]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={logoImage} alt="olym" className={styles.logoImage} />
          <img src={textLogoImage} alt="olym" className={styles.textLogoImage} />
        </div>

        {status === 'loading' && (
          <>
            <div className={styles.spinner} />
            <p className={styles.message}>앱 다운로드 중...</p>
            <p className={styles.subMessage}>잠시만 기다려주세요</p>
          </>
        )}

        {status === 'redirecting' && (
          <>
            <p className={styles.message}>앱스토어로 이동합니다</p>
            <p className={styles.subMessage}>올림 관리자 앱을 설치해주세요</p>
          </>
        )}

        {status === 'desktop' && (
          <>
            <p className={styles.message}>모바일에서 접속해주세요</p>
            <p className={styles.subMessage}>올림 관리자 앱은 모바일에서만 이용 가능합니다</p>
            <div className={styles.storeButtons}>
              <a href={ADMIN_APP_STORE_URL} className={styles.storeButton} target="_blank" rel="noopener noreferrer">
                App Store
              </a>
              <a href={ADMIN_PLAY_STORE_URL} className={styles.storeButton} target="_blank" rel="noopener noreferrer">
                Google Play
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
